export { default as withProfileLikes } from './withProfileLikes';
export { default as withRecentLikes } from './withRecentLikes';
export { default as withToggleLike } from './withToggleLike';



// WEBPACK FOOTER //
// ./src/@data/likes/index.js